import { Show } from "solid-js";
import type { ScanCoverage } from "./scanCoverage";
import { HeroMetric, Info } from "./summaryModel";

export function SummaryScanScope(props: {
  coverage: ScanCoverage;
  combinedCoverage: number | null;
  openIssueCount: number;
  availability: { label: string; detail: string };
  pagesHref: string;
}) {
  return (
    <div class="signal-hero-cell signal-scope-cell">
      <div class="signal-scope-description">
        <span class="signal-card-label">
          Current scan context
          <Info text="Counts come from the current scan inventory, open issues and recorded links." />
        </span>
        <p class="signal-scan-availability">
          <strong>{props.availability.label}</strong>
          <span>{props.availability.detail}</span>
        </p>
      </div>
      <Show
        when={props.combinedCoverage}
        fallback={
          <div class="signal-scope-grid">
            <HeroMetric
              label="Pages in inventory"
              value={`${props.coverage.inventoryPages}`}
            />
            <Show when={typeof props.coverage.completedPages === "number"}>
              <HeroMetric
                label="Pages completed"
                value={`${props.coverage.completedPages ?? 0}`}
              />
            </Show>
            <Show
              when={props.coverage.assessedPages === props.coverage.scoredPages}
              fallback={
                <>
                  <HeroMetric
                    label="Pages assessed"
                    value={`${props.coverage.assessedPages}`}
                  />
                  <HeroMetric
                    label="Pages scored"
                    value={`${props.coverage.scoredPages}`}
                  />
                </>
              }
            >
              <HeroMetric
                label="Pages assessed and scored"
                value={`${props.coverage.scoredPages}`}
              />
            </Show>
            <Show when={(props.coverage.failedPages ?? 0) > 0}>
              <HeroMetric
                label="Pages not completed"
                value={`${props.coverage.failedPages ?? 0}`}
              />
            </Show>
            <Show when={(props.coverage.skippedPages ?? 0) > 0}>
              <HeroMetric
                label="Pages skipped"
                value={`${props.coverage.skippedPages ?? 0}`}
              />
            </Show>
            <HeroMetric label="Open issues" value={`${props.openIssueCount}`} />
          </div>
        }
      >
        {(pageCount) => (
          <div class="signal-scope-grid">
            <HeroMetric
              label={`${pageCount() === 1 ? "Page" : "Pages"} captured, assessed and scored`}
              value={`${pageCount()}`}
            />
            <HeroMetric label="Open issues" value={`${props.openIssueCount}`} />
          </div>
        )}
      </Show>
      <a class="signal-text-action" href={props.pagesHref}>
        Inspect page inventory
      </a>
    </div>
  );
}
